import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant, IconName, IconColor, IconSize, Popover, PopoverSize } from '@as/cotopaxi';
import { useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ForgotPassword } from './ForgotPassword';
import { Login } from './Login';
export const AuthenticationPopover = ({ forgotPassword, login, anchorEl, onClose, registrationLink, onAuthResetForm, forgotPasswordActive, toggleView, onEmailChange, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [email, setEmail] = useState('');
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const handleEmailChange = (email) => {
        setEmail(email);
        onEmailChange === null || onEmailChange === void 0 ? void 0 : onEmailChange(email);
    };
    return (_jsx(Popover, { dataQA: "login_popover", size: PopoverSize.LARGE, onClose: onClose, anchorEl: anchorEl, hasScrollLock: !isDesktop, title: forgotPasswordActive ? t('account.login.title.password.forgotten') : t('account.login.title.login'), rightElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: onClose, icon: {
                name: IconName.CLOSE,
                color: IconColor.ACTION,
                size: IconSize.MAJOR,
            } }), leftElement: forgotPasswordActive ? (_jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: toggleView, noBubble: true, icon: {
                name: IconName.ARROW_LEFT,
                color: IconColor.ACTION,
                size: IconSize.MAJOR,
            } })) : null, children: forgotPasswordActive ? (_jsx(ForgotPassword, Object.assign({}, forgotPassword, { initialEmail: email, backToLoginClicked: toggleView, onEmailChange: handleEmailChange }))) : (_jsx(Login, { login: Object.assign(Object.assign({}, login), { forgotPasswordClicked: toggleView, initialEmail: email }), registrationLink: registrationLink, onAuthResetForm: onAuthResetForm, onEmailChange: handleEmailChange })) }));
};
